export default __webpack_public_path__ + "static/media/ans_1.bbd7e0a9.png";